import { FC, PropsWithChildren } from "react";
import { TranslationScopes } from "@finbackoffice/enums";
import { useRuntimeConfig, useTranslation } from "@finbackoffice/site-core";
import classNames from "classnames";
import Translate from "components/base/translate/Translate";
import ScrollComponent from "components/base/scroll/ScrollComponent";
import Footer from "components/footer/Footer";
import Img from "components/base/img/Img";
import Button from "components/base/button/Button";
import { Svg } from "components/base/svg/Svg";
import styles from "./policies.module.sass";

type IProps = {
    translationKey: string;
    translationScope: TranslationScopes;
    headingIcon: { width: number; height: number };
    wrapperClassName?: string;
    scrollTo?: number | null;
    clearScrollToPos?: () => void;
};

const PoliciesCommonContent: FC<IProps & PropsWithChildren> = ({
    translationKey,
    translationScope,
    children,
    headingIcon,
    wrapperClassName,
    ...rest
}) => {
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    const { t } = useTranslation();

    const onPrintPress = () => {
        const printStyles = `
        @media print {
            body * { visibility: hidden; } 
            body { display: block; height: auto }
            .printContent, .printContent div > section * { visibility: visible; color: black !important;  }
            html body .printContent .svg-sport-icon svg path { fill: black !important }
        }
    `;

        if (!document.getElementById("print-styles")) {
            const style = document.createElement("style");
            style.id = "print-styles";
            style.appendChild(document.createTextNode(printStyles));
            document.head.appendChild(style);
        }

        window.print();

        setTimeout(() => {
            if (document.getElementById("print-styles")) {
                document.getElementById("print-styles")?.remove();
            }
        }, 100);
    };

    return (
        <ScrollComponent containerClass={classNames(styles.navContent, "printContent")} {...rest}>
            <section className={classNames(wrapperClassName)}>
                <div>
                    <h1
                        className={styles.header}
                        data-testid={`policies-${translationKey.replaceAll("_", "-")}-heading`}>
                        <Img
                            source={`${ASSETS_URL}/common/desktop/base-icons/policies-${translationKey.replaceAll("_", "-")}.svg`}
                            alt={t(`pageName_policies_${translationKey}`)}
                            width={headingIcon.width}
                            height={headingIcon.height}
                        />
                        <Translate
                            tid={`policies_${translationKey}_heading`}
                            namespace={translationScope}
                        />
                    </h1>
                    <Button type="button" onClick={onPrintPress} className={styles.print}>
                        <Svg src="/common/desktop/base-icons/print.svg" wrapper="span" />
                        <Translate tid="policies_print" namespace={TranslationScopes.Policies} />
                    </Button>
                </div>
                {children}
            </section>
            <Footer />
        </ScrollComponent>
    );
};

export default PoliciesCommonContent;
